import { Fragment } from "react";
import { useNavigate } from "react-router-dom";

export function Breadcrumb({ items }) {
    const navigate = useNavigate();

    return (
        <Fragment>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    {items.map((item, index) => (
                        <li
                            key={index}
                            className={`breadcrumb-item ${index === items.length - 1 ? "active" : ""}`}
                        >
                            {index === items.length - 1 ? (
                                <span>{item.label}</span>
                            ) : (
                                <span style={{ cursor: "pointer", color: "blue" }} onClick={() => navigate(item.path)}>
                                    {item.label}
                                </span>
                            )}
                        </li>
                    ))}
                </ol>
            </nav>
        </Fragment>
    );
}
